// extracted by mini-css-extract-plugin
module.exports = {"cancelButton":"ApplicationPage_cancelButton__2kw1Z","questionsWrapper":"ApplicationPage_questionsWrapper__nCJFf","saveButton":"ApplicationPage_saveButton__335ye"};